import React from "react";
import { motion } from "framer-motion";
import freshstartImage from "./Images/ditation2.jpg";
import image2 from "../../../Images/coursecard_images/dictation_1.jpg";
import image1 from "../../../Images/coursecard_images/dictation_2.jpg";
import image3 from "../../../Images/coursecard_images/dictation_3.jpg";
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  CardMedia,
  Button,
  List,
  ListItem,
  ListItemText,
  Grid,
} from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import Nav from "../../../Nav";

const DictationCourse = () => {
  return (
    <>
      <motion.div
        className="p-5 font-sans bg-gray-100 h-4/5 mt-20"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* Page Title */}
        <h1 className="text-4xl font-extrabold text-gray-600 text-center mb-8">
          Dictation Course
        </h1>

       
      </motion.div>
      <Nav />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Box
          sx={{
            backgroundColor: "#f8fafc",
            py: 5,
            fontFamily: "Arial, sans-serif",
          }}
        >
          <Box
            sx={{
              backgroundImage: `url(${freshstartImage})`,
              backgroundSize: "cover",
              py: 10,
              textAlign: "center",
              color: "#fff",
            }}
          >
            <Container maxWidth="lg">
              <Typography
                variant="h1"
                align="center"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  fontFamily: "Arial, sans-serif",
                  color: "#fff",
                }}
              >
                Dictation Course
              </Typography>
            </Container>
          </Box>

          <Container
            maxWidth="lg"
            sx={{ backgroundColor: "#ffffff", p: 5, borderRadius: 2, mt: -8 }}
          >
            <Grid container spacing={5} alignItems="flex-start">
              <Grid item xs={12} lg={6}>
                <Typography
                  variant="body1"
                  paragraph
                  sx={{
                    fontFamily: "Arial, sans-serif",
                    lineHeight: 1.6,
                    color: "#6b778c",
                  }}
                >
                  Develop your listening and build your vocabulary. This unique
                  dictation course is not available anywhere else. This
                  technique is even used in schools as a part of the student
                  curriculum. But how does it work?
                </Typography>
                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{
                    fontWeight: "bold",
                    fontFamily: "Arial, sans-serif",
                    color: "#172b4d",
                  }}
                >
                  What is dictation?
                </Typography>
                <Typography
                  variant="body1"
                  paragraph
                  sx={{
                    fontFamily: "Arial, sans-serif",
                    lineHeight: 1.6,
                    color: "#6b778c",
                  }}
                >
                  Dictation involves one person reading aloud a passage,
                  sentence, or words, while others write down exactly what is
                  said. The key goal is accuracy in listening and writing. The
                  speaker typically reads at a pace that allows the listeners to
                  comprehend and transcribe the material correctly.
                </Typography>
                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{
                    fontWeight: "bold",
                    fontFamily: "Arial, sans-serif",
                    color: "#172b4d",
                  }}
                >
                  How does it work?
                </Typography>
                <Typography
                  variant="body1"
                  paragraph
                  sx={{
                    fontFamily: "Arial, sans-serif",
                    lineHeight: 1.6,
                    color: "#6b778c",
                  }}
                >
                  If you can’t hear native or non-native speakers you need to{" "}
                  <b>
                    <i>improve your listening capacity.</i>
                  </b>{" "}
                  The audio in the course simply replaces the person who repeats
                  the sentences out loud, such as the school teacher.
                </Typography>
                <Typography
                  variant="body1"
                  paragraph
                  sx={{
                    fontFamily: "Arial, sans-serif",
                    lineHeight: 1.6,
                    color: "#6b778c",
                  }}
                >
                  You rely on your listening skills and keep writing what you
                  hear in the audio recording.
                </Typography>
              </Grid>
              <Grid item xs={12} lg={6}>
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  <CardMedia
                    component="img"
                    image={freshstartImage}
                    alt="Fresh Start"
                    sx={{ borderRadius: 2 }}
                  />
                </motion.div>
              </Grid>
            </Grid>

            <Typography
              variant="body1"
              paragraph
              sx={{
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#6b778c",
              }}
            >
              Once you finish you can compare your writing with the original and
              check for any mistakes. Identifying the words correctly in English
              is rather challenging for many people.
            </Typography>
            <Typography
              variant="body1"
              paragraph
              sx={{
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#6b778c",
              }}
            >
              <u>
                This course is unique and you will not find it anywhere else.
              </u>{" "}
              I developed this course with your needs in mind and solely based
              on my experience teaching numerous students English in the past
              years. As a result they not only improved their listening but it
              helped them feel more comfortable with English at work and in
              their daily life.
            </Typography>
            <Typography
              variant="body1"
              paragraph
              sx={{
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#6b778c",
              }}
            >
              This training is directly connected with essential skills in
              English, listening, and speaking.
            </Typography>
            <Typography
              variant="body1"
              paragraph
              sx={{
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#6b778c",
              }}
            >
              <i>
                <b>
                  Speaking and listening represent your ability to express
                  yourself and understand others.
                </b>
              </i>{" "}
              This course is carefully crafted to assist you in just that.
            </Typography>

            <Grid item xs={12} lg={10}>
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CardMedia
                  component="img"
                  image={image2}
                  alt="Fresh Start"
                  sx={{
                    borderRadius: 2,
                    width: "100%",
                    marginBottom: "19px",
                  }}
                />
              </motion.div>
            </Grid>
            <Typography
              variant="h5"
              gutterBottom
              sx={{
                fontWeight: "bold",
                fontFamily: "Arial, sans-serif",
                color: "#172b4d",
              }}
            >
              Uses of Dictation in Studying English
            </Typography>
            <Typography
              variant="body1"
              paragraph
              sx={{
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#6b778c",
              }}
            >
              1.{" "}
              <i>
                <b>Listening Skills:</b>
              </i>{" "}
              Dictation exercises help you improve your ability to listen
              carefully and understand spoken English.
              <b>
                <u>
                  <i>
                    {" "}
                    It trains you to catch every word and nuance in
                    pronunciation.
                  </i>
                </u>
              </b>
            </Typography>
            <Typography
              variant="body1"
              paragraph
              sx={{
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#6b778c",
              }}
            >
              2.
              <i>
                <b> Spelling and Grammar:</b>
              </i>{" "}
              As you write down what you hear, you must also pay attention to
              the{" "}
              <b>
                <u>
                  <i>correct spelling and grammatical structure.</i>
                </u>
              </b>{" "}
              This practice reinforces your
              <i>
                <u>
                  <b> knowledge of English syntax and vocabulary.</b>
                </u>
              </i>
            </Typography>
            <Typography
              variant="body1"
              paragraph
              sx={{
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#6b778c",
              }}
            >
              3.{" "}
              <i>
                <b>Writing and Punctuation:</b>
              </i>{" "}
              Dictation requires that you understand how to
              <i>
                <b>
                  <u>
                    {" "}
                    correctly punctuate sentences based on the pauses and
                    inflections you hear,
                  </u>
                </b>
              </i>{" "}
              which can{" "}
              <b>
                <i>
                  <u> improve your written English.</u>
                </i>
              </b>
            </Typography>
            <Typography
              variant="body1"
              paragraph
              sx={{
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#6b778c",
              }}
            >
              4.
              <i>
                <b> Vocabulary Building:</b>
              </i>{" "}
              Being exposed to new words in context during dictation helps in
              enhancing vocabulary retention and usage.
              <b>
                <i>
                  <u> Leave your comfort zone and grow! </u>
                </i>
              </b>
            </Typography>
            <Typography
              variant="body1"
              paragraph
              sx={{
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#6b778c",
              }}
            >
              5.{" "}
              <i>
                <b>Focus and Concentration:</b>
              </i>{" "}
              <u>
                <i>
                  This activity demands high concentration and attention to
                  detail, skills that are beneficial across all areas of
                  learning. It can benefit your career greatly, and it’s worth
                  your time.
                </i>
              </u>
            </Typography>

            <Grid item xs={12} lg={11} container spacing={2}>
              <Grid item xs={6} paddingBottom={"20px"}>
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  <CardMedia
                    component="img"
                    image={image1}
                    alt="Fresh Start"
                    sx={{ borderRadius: 2 }}
                  />
                </motion.div>
              </Grid>
              <Grid item xs={6}>
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  <CardMedia
                    component="img"
                    image={image3}
                    alt="Fresh Start"
                    sx={{ borderRadius: 2 }}
                  />
                </motion.div>
              </Grid>
            </Grid>
            <Typography
              variant="body1"
              paragraph
              sx={{
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#6b778c",
              }}
            >
              This free-style course gives you the chance to study at your own
              pace. The best thing about this course it the total absence of
              pressure. You’re learning and making progress most naturally - by
              listening.
            </Typography>
            <Typography
              variant="body1"
              paragraph
              sx={{
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#6b778c",
              }}
            >
              You can easily integrate this course with any other course to
              boost your learning and achieve your objectives easier.
            </Typography>
            <Typography
              variant="body1"
              paragraph
              sx={{
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#6b778c",
              }}
            >
              1-year access
            </Typography>
            <Typography
              variant="body1"
              paragraph
              sx={{
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#6b778c",
              }}
            >
              New audio recordings are added monthly.
            </Typography>
            <div className="flex flex-col md:flex-row gap-6 items-center justify-center">
          {/* Card 1: Course Details */}
          <div className="w-full md:w-1/2 bg-green-100 shadow-lg rounded-lg p-6">
            <p className="text-gray-700 mb-2">
              <strong>Type of course:</strong> Self studying course
            </p>
            <p className="text-gray-700 mb-2">
              <strong>Number of lessons:</strong> 40 Audio files and PDF texts.
            </p>
            <p className="text-gray-700 mb-2">
              <strong>Price:</strong> $360 (paid $ 30 monthly) or $ 280
              annually.
            </p>
            <p className="italic text-gray-600 mt-4 text-center">
              COMING in January 2025
            </p>
          </div>

          {/* Card 2: Bundle Pricing */}
          <div className="w-full md:w-1/2 bg-blue-100 shadow-lg rounded-lg p-6">
            <h2 className="text-2xl font-bold text-gray-800 text-center mb-4">
              Bundle Price Option
            </h2>
            <p className="text-gray-700 mb-4 text-center">
              <strong>Bundle Price:</strong>$ 0 / 1 year access / Value: $ 280
            </p>
          </div>
        </div>
            <Box textAlign="center" mb={10} mt={2}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                sx={{ borderRadius: 5, px: 5, py: 2 }}
              >
                Join Now
              </Button>
            </Box>
          </Container>
        </Box>
      </motion.div>
    </>
  );
};

export default DictationCourse;
